<template>
	<div>

		<v-file-input
			:label="label"
			:placeholder="placeholder"
			:prepend-icon="prependIcon"
			mmmmmultiple="multiple"
			:accept="accept"
			:chips="chips"
			:dense="dense"
			:rules="rules"
			show-size
			clear-icon="mdi-close"
			@change="onChange"
			@input="$emit('input')"
		></v-file-input>

		<v-progress-linear
			v-if="cargando"
      v-model="progreso"
			color="green"
      height="20"
    >
      {{ Math.ceil(progreso) }}%
    </v-progress-linear>

		<v-alert v-if="cargado" type="success" icon="mdi-check-circle" dense>
      Archivo cargado
    </v-alert>

		<v-alert v-if="sobrescribir" icon="mdi-alert-circle-outline" type="warning" class="mt-3">
      Ya existe un archivo con el nombre «<em>{{nombre}}</em>». Si continúa, reemplazará el archivo existente por el que está subiendo.
			<br>
			<v-divider></v-divider>
			<br>
			<v-btn color="error" @click="subirArchivo">Subir y reemplazar el archivo</v-btn>
			&nbsp;&nbsp;&nbsp;&nbsp;
			<v-btn @click="sobrescribir = false; progreso = 0; cargando = false; archivo = null">Cancelar la subida</v-btn>
    </v-alert>

	</div>
</template>

<script>

//import Compressor from 'compressorjs'
import * as firebase from "firebase/app";
import { imágenes } from '@/utilidades.js'

export default {
  name: 'SubirArchivo',

  data: () => ({
		progreso: 0,
		cargando: false,
		cargado: false,
		sobrescribir: false,
		nombre: '',
		referencia: '',
		archivo: null,
	}),
	
	props: {
		value: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: 'Archivo'
		},
		multiple: { // Esto no porque cambiaría el manejo de la caga automática.....
			type: Boolean,
			default: false
		},
		accept: {
			type: String,
			default: '*'
		},
		chips: {
			type: Boolean,
			default: false
		},
		prependIcon: {
			type: String,
			default: 'mdi-paperclip'
		},
		dense: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		rules: {
			type: Array
		},
	},

	methods: {
		onChange: function(v) {
			if (!v) {
				return
			}

			this.archivo = null
			this.progreso = 0
			this.cargado = false
			this.sobrescribir = false

			if (v.size > 5000000) {
				this.$root.error('El archivo es muy grande. Asegúrate de no subir archivos de más de 5MB.')
				return
			}

			this.cargando = true

			this.archivo = v
			this.nombre = this.archivo.name.replace(/[\[\]\#\*\?]/g, '_')
			this.referencia = this.$root.storageRef.child(this.nombre)

			this.referencia.getDownloadURL().then( downloadURL => {
				this.sobrescribir = true
			}).catch( err => {
				if (err.code === 'storage/object-not-found') {
					this.subirArchivo()
				} else {
					this.progreso = 0
					this.cargando = false
					this.$root.error('[4738] Ocurrió un error. Recarga la página e intenta de nuevo.')
				}
			})

		},
		subirArchivo: function() {
			this.sobrescribir = false
			this.cargarArchivo(this.archivo, this.nombre)
		},
		cargarArchivo: function(arch, nombre) {
			let tipo = 'otro'
			if (arch.type.indexOf('image') === 0) {
				tipo = 'imagen'
			} else if (arch.type.indexOf('audio') === 0) {
				tipo = 'audio'
			} else if (arch.type.indexOf('video') === 0) {
				tipo = 'video'
			}

			let referencias = [this.referencia]
			let P = null

			if (tipo === 'imagen') {
				P = imágenes.construirVariantes(arch).then(obj => {
					let pdzs = nombre.split('.')
					let ext = pdzs.pop()
					let nomMiniatura = pdzs.join('.') + '-miniatura.' + ext
					let nomMediana = pdzs.join('.') + '-mediana.' + ext
					let refMiniatura = this.$root.storageRef.child(nomMiniatura)
					let refMediana = this.$root.storageRef.child(nomMediana)
					referencias.push(refMiniatura)

					let cargas = []
					cargas.push(this.cargar(refMiniatura, obj.miniatura, false))
					if (obj.mediana) {
						cargas.push(this.cargar(refMediana, obj.mediana, false))
						referencias.push(refMediana)
					}

					return Promise.all(cargas).then(crgs => {
						return this.cargar(this.referencia, obj.original, true).then(rta => {
							let oi = {
								peso: obj.peso,
								imagen: {
									miniatura: crgs[0].ubicación,
									mediana: crgs[1] ? crgs[1].ubicación : '',
								}
							}
							return Promise.resolve(Object.assign(rta, oi))
						})
					})
				})
			} else {
				P = this.cargar(this.referencia, arch, true)
			}

			P.then(dts => {
				let datos = {
					ubicación: dts.ubicación,
					peso: dts.peso || arch.size,
					tipo: tipo,
					mime: arch.type,
					fechaDeCreación: firebase.firestore.FieldValue.serverTimestamp(),
				}

				if (tipo === 'imagen') {
					datos.imagen = dts.imagen
				}

				return this.$root.firestore.collection('cuentas').doc(this.$root.cuenta.identificador).collection('archivos').add(datos).then( docRef => {
					//this.cargado = true
					//this.cargando = false
					//this.$emit('input', datos.ubicación)
					return datos
				})/*.catch( err => {
					this.cargando = false
					console.error('[4793]', err)
					this.$root.error(err.error || '[4793] Ocurrió un error')
				})*/

			}).then(datos => {
				this.cargado = true
				this.cargando = false
				this.$emit('input', datos.ubicación)
			}).catch(err => {
				this.cargando = false
				console.error('[4794]', err)
				this.$root.error(err.error || '[4794] Ocurrió un error')
				for (let ref of referencias) {
					ref.delete()
				}
			})

		},
		cargar: function(ref, arch, indicadores) {
			//let carga = this.referencia.put(arch)
			let carga = ref.put(arch)

			return new Promise((resolve, reject) => {
				carga.on('state_changed', snapshot => {
					if (indicadores) {
						this.progreso = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					} else {
						this.progreso = 1
					}
						/*switch (snapshot.state) {
							case firebase.storage.TaskState.PAUSED: // or 'paused'
								console.log('Upload is paused');
								break;
							case firebase.storage.TaskState.RUNNING: // or 'running'
								console.log('Upload is running');
								break;
						}*/
				}, error => {
					let err = '[7893] Ocurrió un error'
					switch (error.code) {
						case 'storage/unauthenticated':
							err = 'Tu sesión caducó. Recarga la página e inicia sesión de nuevo.'
							break;
						case 'storage/canceled':
							err = 'Cancelaste la carga.'
							break;
					}
					reject({ error: err })
				}, () => {
					carga.snapshot.ref.getDownloadURL().then( downloadURL => {
						resolve({ ubicación: downloadURL + '?alt=media' })
					});
				});
			})
		},
	}
};

</script>